import { render, staticRenderFns } from "./UcCompactCompanyDisplay.yaml?vue&type=template&id=524657ca&component"
import script from "./UcCompactCompanyDisplay.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompactCompanyDisplay.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports